import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=2ef3a48d&scoped=true&"
import script from "./agreement.vue?vue&type=script&lang=js&"
export * from "./agreement.vue?vue&type=script&lang=js&"
import style0 from "./agreement.vue?vue&type=style&index=0&id=2ef3a48d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef3a48d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef3a48d')) {
      api.createRecord('2ef3a48d', component.options)
    } else {
      api.reload('2ef3a48d', component.options)
    }
    module.hot.accept("./agreement.vue?vue&type=template&id=2ef3a48d&scoped=true&", function () {
      api.rerender('2ef3a48d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/print/components/agreement.vue"
export default component.exports